import { ACTIONS } from 'redux-api-call';
import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { DELETE_STAFF_API_ID } from '../../apiCalls/adminStaffs/delete';
import routerHistory from '../../routerHistory';

const handleDeleteStaffSuccess = (actions$, store$) =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(DELETE_STAFF_API_ID))),
    map(() => {
      routerHistory.push(`/iam/staffs`);
    })
  );

export default handleDeleteStaffSuccess;
